export const TYPES = {
  SELECT_COMPANY_NAME: "time/SELECT_COMPANY_NAME",
  SELECT_TIME_FROM: "time/SELECT_TIME_FROM",
  SELECT_TIME_TO: "time/SELECT_TIME_TO",
  SELECT_EDITABLE: "time/SELECT_EDITABLE",
  SELECT_USER: "time/SELECT_USER",
  //
  SELECT_REPORT_DATA: "time/SELECT_REPORT_DATA",
  SELECT_TOTAL_WORKING: "time/SELECT_TOTAL_WORKING",
  SELECT_TOTAL_BREAKING: "time/SELECT_TOTAL_BREAKING",
  SELECT_RANGE: "time/SELECT_RANGE",
  //
  SELECT_PHOTOS: "time/SELECT_PHOTOS",
  SELECT_LOCATION: "time/SELECT_LOCATION",
  //dialog
  SELECT_OPEN: "time/SELECT_OPEN",
  SELECT_DIALOG_DATE: "time/SELECT_DIALOG_DATE",
  SELECT_DIALOG_TIME: "time/SELECT_DIALOG_TIME",
};
